"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_1 = __importDefault(require("@streem/analytics"));
const api_1 = require("@streem/api");
const openapi_1 = require("@streem/api/src/openapi");
const auth_1 = __importStar(require("@streem/auth"));
const domain_id_1 = require("@streem/domain-id");
const logger_1 = require("@streem/logger");
const sdk_araas_1 = require("@streem/sdk-araas");
const sdk_streem_wall_1 = require("@streem/sdk-streem-wall");
const sdk_twilio_video_1 = require("@streem/sdk-twilio-video");
const sdk_twilio_wall_1 = require("@streem/sdk-twilio-wall");
const sdk_chime_video_1 = require("@streem/sdk-chime-video");
const detect_browser_1 = require("detect-browser");
const rxjs_1 = require("rxjs");
const geolocation_controller_1 = require("./data/controllers/geolocation_controller");
const detail_session_1 = require("./data/session/detail_session");
const user_session_1 = require("./data/session/user_session");
const streem_error_1 = require("./streem_error");
const active_tab_election_1 = require("./util/active_tab_election");
const determine_supported_video_codecs_1 = require("./util/determine_supported_video_codecs");
const determine_supported_video_platforms_1 = require("./util/determine_supported_video_platforms");
const storage_1 = require("./util/dom/storage");
const logger_2 = require("./util/logger");
class Streem {
    constructor() {
        this.configuredSubject = new rxjs_1.BehaviorSubject(false);
        this.configured = this.configuredSubject.asObservable();
        this.userSessionSubject = new rxjs_1.BehaviorSubject(undefined);
        this.userSession = this.userSessionSubject.asObservable();
        this.isLeaderSessionSubject = new rxjs_1.BehaviorSubject(false);
        this.isLeaderSession = this.isLeaderSessionSubject.asObservable();
        this.handleAuthCallback = (authUser) => __awaiter(this, void 0, void 0, function* () {
            this.clearUserSession();
            // Do not try to register a non-user or LoginIdentityUser.
            if (!authUser || (0, auth_1.isLoginIdentityUser)(authUser)) {
                return;
            }
            const userId = new domain_id_1.UserId(authUser.id);
            const deviceId = yield this.registerDeviceAndIdentifyUser(authUser);
            yield this.startUserSession(userId, deviceId);
        });
    }
    /**
     * Configure the Streem SDK
     */
    configure(config) {
        if (!config || !config.appId) {
            throw new streem_error_1.StreemError('appId is required to initialize Streem');
        }
        this.appVersion = config.appVersion || '1'; // '1' is expected to be used for localhost only.
        geolocation_controller_1.GeolocationController.GoogleMapsKey = config.googleMapsKey;
        (0, logger_2.setLogger)(config.logger);
        (0, sdk_twilio_video_1.configureTwilioLogger)(config.logger.extend('sdk-twilio-video'));
        (0, sdk_araas_1.configureARaaSLogger)(config.logger.extend('sdk-araas'));
        (0, sdk_twilio_wall_1.configureTwilioWallLogger)(config.logger.extend('sdk-twilio-wall'));
        (0, sdk_chime_video_1.configureChimeVideo)({ logger: config.logger.extend('sdk-chime-video') });
        (0, sdk_streem_wall_1.configureStreemWallSdk)({
            logger: config.logger.extend('sdk-streem-wall'),
            wallBaseUrl: config.wallUrl.replace(/\/$/, ''),
        });
        (0, active_tab_election_1.requestTabLeadership)().then(() => {
            this.isLeaderSessionSubject.next(true);
            logger_2.logger.info('Leader Streem tab set');
        });
        try {
            this.appId = new domain_id_1.AppId(config.appId);
            auth_1.default.onAuthStateChanged(this.handleAuthCallback);
            this.configuredSubject.next(true);
        }
        catch (e) {
            logger_2.logger.error('failed to configure Streem SDK', e);
            throw new streem_error_1.StreemError('Internal Error');
        }
    }
    startAnonymousDetailSession(roomSid, shareToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.configuredSubject.value) {
                throw new Error('Streem must be configured before starting a session');
            }
            api_1.StreemAPI.setShareToken(shareToken);
            const deviceId = yield this.registerDevice();
            const detailSession = yield detail_session_1.DetailSession.initialize({
                roomId: new domain_id_1.RoomId(roomSid),
                deviceId,
                readOnly: true,
            });
            yield detailSession.connect();
            return detailSession;
        });
    }
    startUserSession(userId, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const session = yield user_session_1.UserSession.initialize({
                userId,
                deviceId,
            });
            yield session.connect();
            this.userSessionSubject.next(session);
        });
    }
    /**
     * Identify the user to platform
     */
    registerDeviceAndIdentifyUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const deviceId = yield this.registerDevice();
                const userMeta = {
                    deviceSid: deviceId.toString(),
                    isExpert: (0, auth_1.isExpertUser)(user),
                };
                if ((0, auth_1.isExpertUser)(user) || (0, auth_1.isLoginIdentityUser)(user)) {
                    userMeta.name = user.name;
                    userMeta.avatarUrl = user.avatarUrl;
                    userMeta.email = user.email;
                }
                yield api_1.StreemAPI.users.identifyUser(user.id, userMeta);
                logger_2.logger.debug(`Identifying user ${user.id} with device ${deviceId}`);
                return deviceId;
            }
            catch (e) {
                logger_2.logger.error('Failed to register device and identify user', e);
                throw new streem_error_1.StreemError('Internal Error');
            }
        });
    }
    registerDevice(deviceIdOverride) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const deviceCountry = () => {
                    const localSplit = navigator.language.split('-') || [];
                    return localSplit[1];
                };
                const localId = deviceIdOverride || (0, storage_1.retrieveIdentifier)();
                const deviceInfo = {
                    sid: localId.toString(),
                    appSid: this.appId.toString(),
                    appVersion: this.appVersion,
                    deviceCountry: deviceCountry(),
                    deviceLocale: navigator.languages[0],
                    // eslint-disable-next-line new-cap
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    platform: 'web',
                    userAgent: window.navigator.userAgent,
                    supportedVideoCodecs: yield (0, determine_supported_video_codecs_1.determineSupportedVideoCodecs)(window.navigator.userAgent, (0, detect_browser_1.detect)()),
                    supportedVideoPlatforms: (0, determine_supported_video_platforms_1.determineSupportedVideoPlatforms)(),
                    supportedWallPlatforms: [
                        openapi_1.StreemApiDeviceSupportedWallPlatforms.TWILIO,
                        openapi_1.StreemApiDeviceSupportedWallPlatforms.STREEM,
                    ],
                };
                yield api_1.StreemAPI.devices.updateDevice(localId.toString(), {
                    device: deviceInfo,
                });
                analytics_1.default.setDeviceId(localId);
                logger_2.logger.setContextValue(logger_1.contextValues.DEVICE_INFO, deviceInfo);
                logger_2.logger.debug(`Device registered with id: ${localId}`);
                return localId;
            }
            catch (error) {
                // TODO look into addressing the fact that you can get into a state where your deviceId is already in use
                // see: https://streempro.atlassian.net/browse/STREEM-2896
                if (error.status === 409 && !deviceIdOverride) {
                    try {
                        const type = sessionStorage.getItem('appType');
                        const typeApp = type != null ? type : 'ev2';
                        yield this.registerDevice((0, storage_1.generateNewIdentifier)(typeApp));
                    }
                    catch (e) {
                        logger_2.logger.error('Failed to register device', e);
                        throw new streem_error_1.StreemError('Internal Error');
                    }
                }
                throw error;
            }
        });
    }
    clearUserSession() {
        if (this.userSessionSubject.value) {
            this.userSessionSubject.value.disconnect();
            this.userSessionSubject.next(undefined);
        }
    }
}
// This is a singleton, default export is valid here.
// eslint-disable-next-line import/no-default-export
exports.default = new Streem();
//# sourceMappingURL=streem.js.map